<template>
  <div class="create-sportsbooks pb-8">
    <v-app-bar flat color="transparent" class="main-appbar">
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">{{ pageTitle }}</h1>
        </v-toolbar-title>
      </div>
      <v-spacer/>

      <v-btn
        text
        class="ml-4"
        :loading="form.$busy"
        :to="{name: 'sportsbooks.list'}"
      >
        <span style="text-transform: none">Cancel</span>
      </v-btn>

      <v-btn
        color="primary"
        dark
        class="ml-4"
        :loading="form.$busy"
        @click="save"
      >
        <span style="text-transform: none">Save</span>
      </v-btn>

      <v-btn
        color="primary"
        dark
        class="ml-4"
        :loading="form.$busy"
        @click="togglePublish"
      >
        <span style="text-transform: none">{{ isPublished ? 'Unpublish' : 'Publish'}}</span>
      </v-btn>
    </v-app-bar>

    <v-tabs
      v-model="tab"
      background-color="transparent"
      grow
      >
      <v-tab
        v-for="item in tabItems"
        :key="item"
      >
        {{ item }}
      </v-tab>
      <v-tabs-items v-model="tab">
        <v-tab-item  key="Details">
          <v-row  class="details-container">
            <v-col lg="8">
              <v-card outlined  class="px-6 py-8">
                <v-row>
                  <v-col sm="7">
                    <image-uploader
                      suggestedWidth="1110"
                      suggestedHeight="245"
                      v-model="form.banner_logo"
                      uploadLabel="Large Banner Image (Bookie Reviews)"/>
                  </v-col>
                  <v-col sm="5">
                    <v-row>
                      <v-col sm="12">
                        <image-uploader
                          suggestedWidth="350"
                          suggestedHeight="175"
                          height="175"
                          v-model="form.welcome_logo"
                          uploadLabel="Logo for Best Books"/>
                      </v-col>
                      <v-col sm="12">
                        <image-uploader
                          suggestedWidth="290"
                          suggestedHeight="72"
                          height="72"
                          v-model="form.logo"
                          uploadLabel="Regular Logo(Promo Head)"/>
                      </v-col>
                      <v-col sm="12">
                        <image-uploader
                          suggestedWidth="45"
                          suggestedHeight="45"
                          height="45"
                          v-model="form.small_logo"
                          uploadLabel="Small Logo"/>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>


                <v-text-field
                  class="mt-3"
                  outlined label="Name"
                  v-model="form.name"
                  :error-messages="form.$getError('name')"/>

                <v-text-field
                  outlined
                  label="Website URL"
                  v-model="form.website_url"
                  :error-messages="form.$getError('website_url')"/>

                <v-row>
                  <v-col lg="7" class="py-0">
                    <v-text-field
                      outlined
                      label="BetHub Code"
                      v-model="form.bethub_code"
                      :error-messages="form.$getError('bethub_code')"/>
                  </v-col>

                  <v-col lg="5" class="py-0">
                    <color-picker
                      v-model="form.hex_color"
                      :error-messages="form.$getError('hex_color')"/>
                  </v-col>
                </v-row>

                <us-states-selector
                  v-model="states"
                  :error-messages="form.$getError('states')" />

                <v-textarea
                  outlined
                  label="Description"
                  v-model="form.content_description"
                  :error-messages="form.$getError('content_description')"/>
              </v-card>

              <v-card outlined class="px-6 py-8 mt-6">
                <div class="d-flex flex-row justify-space-between align-center pb-3 ">
                  <label class="subtitle-1 d-block grey--text">Why Join?</label>
                </div>

                <v-textarea
                  outlined
                  label="Description"
                  v-model="form.why_description"
                  :error-messages="form.$getError('why_description')" />

                <div class="d-flex flex-row justify-space-between align-center pb-3 ">
                  <label class="subtitle-1 d-block grey--text">Reasons</label>
                  <v-btn
                    text
                    small
                    class="text-transform-none"
                    color="primary"
                    v-show="get(form, 'why_checklist.length', 0) < 3"
                    @click="addReason">Add Reason</v-btn>
                </div>
                <v-text-field
                  v-for="(reason, i) in form.why_checklist"
                  :key="i"
                  outlined
                  v-model="form.why_checklist[i]"
                  append-icon="mdi-delete"
                  :error-messages="form.$getError('why_checklist')"
                  @click:append="removeReason(i)">
                </v-text-field>
              </v-card>

              <v-card outlined class="px-6 py-8 mt-6">
                <div class="d-flex flex-row justify-space-between align-center pb-3 ">
                  <label class="subtitle-1 d-block grey--text">Call To Action</label>
                </div>

                <v-text-field
                  outlined
                  label="Title"
                  v-model="form.cta_title"
                  :error-messages="form.$getError('cta_title')"/>

                <v-text-field
                  outlined
                  label="Signup URL"
                  :error-messages="form.$getError('cta_url')"
                  v-model="form.cta_url" />

                <v-text-field
                  outlined
                  label="Button Text"
                  v-model="form.cta_btn_text"
                  :error-messages="form.$getError('cta_btn_text')"
                  hint="This will be used on all CTA buttons for this SportsBook."
                ></v-text-field>

                <div class="d-flex flex-row justify-space-between align-center pb-3 ">
                  <label class="subtitle-1 d-block grey--text">Bonuses</label>
                  <v-btn
                    text
                    small
                    class="text-transform-none"
                    color="primary"
                    v-show="get(form, 'cta_bonuses.length', 0) < 3"
                    @click="addBonus">Add Bonus</v-btn>
                </div>

                <v-text-field
                  v-for="(reason, i) in form.cta_bonuses"
                  :key="i"
                  outlined
                  v-model="form.cta_bonuses[i]"
                  append-icon="mdi-delete"
                  :error-messages="form.$getError('cta_bonuses')"
                  @click:append="removeBonus(i)">
                </v-text-field>
              </v-card>
            </v-col>
            <v-col lg="4">
              <slug-generator
                :baseString="form.name"
                v-model="form.slug" />

              <social-sharing-meta-tag
                v-bind:title.sync="form.title_meta"
                v-bind:description.sync="form.description_meta"
                v-bind:image.sync="form.image_meta"
                class="mt-6" />

            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item key="Promos">
          <div class="promos-container">
            <v-row v-if="form.promos && form.promos.length > 0">
              <v-col lg="4" md="6" sm="12" v-for="(promo, i) in form.promos" :key="i">
                <promo-card-item :promo="promo" @remove="removePromo(i)" @change="changePromo(i, $event)"/>
              </v-col>
            </v-row>
            <div v-else class="pt-12 mt-12 fill-height d-flex flex-column align-center justify-center">
              <img style="max-width:250px" :src="require('@/assets/images/undraw_no_data_qbuo.svg')" />
            </div>
          </div>
        </v-tab-item>

        <v-tab-item key="Review">
          <v-row>
            <v-col xl="4">
              <v-card outlined class="px-6 py-8">
                <user-avatar-uploader v-model="form.review_avatar" clearable/>

                <v-text-field
                  outlined
                  label="Author"
                  class="mt-6"
                  v-model="form.review_author_name"
                  :error-messages="form.$getError('review_author_name')"  />

                <v-select
                  outlined
                  label="Review Status"
                  v-model="form.review_publish_status"
                  :items="publishStatusOptions"
                  :error-messages="form.$getError('review_publish_status')"  />

                <v-text-field
                  outlined
                  label="Rating"
                  v-model="form.review_rating"
                  :error-messages="form.$getError('review_rating')" />
              </v-card>
            </v-col>
            <v-col xl="8">
              <v-card outlined class="px-6 py-8">
                <content-editor label="Review"
                  v-model="form.review_description"
                  :error-messages="form.$getError('review_description')" />
              </v-card>
              <v-row class="mt-4">
                <v-col xl="6">
                  <v-card outlined class="px-6 py-8">
                    <div class="d-flex flex-row justify-space-between align-center pb-3 ">
                      <label class="subtitle-1 d-block blue--text">Pros</label>
                      <v-btn
                        text
                        small
                        class="text-transform-none"
                        color="primary"
                        v-show="get(form, 'review_pros.length', 0) < 3"
                        @click="addReviewPros">Add</v-btn>
                    </div>
                    <v-text-field
                      v-for="(pros, i) in form.review_pros"
                      :key="i"
                      outlined
                      v-model="form.review_pros[i]"
                      append-icon="mdi-delete"
                      :error-messages="form.$getError('review_pros')"
                      @click:append="removeReviewPros(i)">
                    </v-text-field>
                  </v-card>
                </v-col>
                <v-col xl="6">
                  <v-card outlined class="px-6 py-8">
                    <div class="d-flex flex-row justify-space-between align-center pb-3 ">
                      <label class="subtitle-1 d-block red--text">Cons</label>
                      <v-btn
                        text
                        small
                        class="text-transform-none"
                        color="primary"
                        v-show="get(form, 'review_cons.length', 0) < 3"
                        @click="addReviewCons">Add</v-btn>
                    </div>
                    <v-text-field
                      v-for="(cons, i) in form.review_cons"
                      :key="i"
                      outlined
                      v-model="form.review_cons[i]"
                      append-icon="mdi-delete"
                      :error-messages="form.$getError('review_cons')"
                      @click:append="removeReviewCons(i)">
                    </v-text-field>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item key="Services">
          <v-row>
            <v-col xl="4" v-for="(service, i) in form.services" :key="i">
              <v-card outlined class="px-6 py-8">
                <div class="d-flex flex-row justify-space-between align-center pb-3 ">
                  <label class="subtitle-1 d-block">{{ service.category }}</label>
                  <v-btn
                    text
                    small
                    class="text-transform-none"
                    color="primary"
                    @click="addServiceCategoryDetails(i)">Add</v-btn>
                </div>
                <v-text-field
                  v-for="(cons, k) in service.category_details"
                  :key="k"
                  outlined
                  v-model="form.services[i].category_details[k]"
                  append-icon="mdi-delete"
                  @click:append="removeServiceCategoryDetails(i, k)">
                </v-text-field>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item key="FAQ">
          <div class="faq-container">
            <v-row v-if="form.faqs && form.faqs.length > 0" style="max-width:1020px" class="mx-auto">
              <v-col lg="12" sm="12" v-for="(faq, i) in form.faqs" :key="i">
                <v-card class="px-6 py-8" outlined>
                  <v-textarea
                    outlined
                    label="Question"
                    v-model="form.faqs[i].question"
                    :error-messages="form.$getError('faqs.'+ i +'.question')"/>

                  <content-editor
                    label="Answer"
                    v-model="form.faqs[i].answer"
                    :error-messages="form.$getError('faqs.'+ i +'.answer')"/>

                  <v-card-actions >
                    <v-spacer></v-spacer>
                    <v-btn text class="text-transform-none red--text" @click="removeFAQ(i)">Remove</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <div v-else class="pt-12 mt-12 fill-height d-flex flex-column align-center justify-center">
              <img style="max-width:250px" :src="require('@/assets/images/undraw_questions_75e0.svg')" />
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

    <promo-modal-form v-model="showPromoModalForm" @success="addPromo"/>
    <faq-modal-form v-model="showFaqModalForm" @success="addFAQ"/>

    <v-btn
      v-show="tab === tabKey.promo"
      @click="showPromoModalForm = true"
      fixed
      right
      bottom
      fab
      color="success"
      large
      class="mx-8 my-4 text-transform-none">
      <v-icon dark>mdi-plus</v-icon>
    </v-btn>

    <v-btn
      v-show="tab === tabKey.faq"
      @click="showFaqModalForm = true"
      fixed
      right
      bottom
      fab
      color="success"
      large
      class="mx-8 my-4 text-transform-none">
      <v-icon dark>mdi-plus</v-icon>
    </v-btn>

    <v-snackbar v-model="snackbar.show" right bottom :color="snackbar.color">
      {{ snackbar.message }}
      <template v-slot:action>
        <v-btn class="text-capitalize" text @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ColorPicker from '../components/ColorPicker'
import ImageUploader from '../components/ImageUploader'
import PromoModalForm from '../components/PromoModalForm'
import FaqModalForm from '../components/FaqModalForm'
import PromoCardItem from '../components/PromoCardItem'
import Form from '@/utils/form'
import get from 'lodash/get'
import map from 'lodash/map'
import Bookmaker from '@/models/BookMaker'
import UsStatesSelector from '@/components/UsStatesSelector'
import filter from 'lodash/filter'
import UserAvatarUploader from '@/components/UserAvatarUploader'
import ContentEditor from '@/components/ContentEditor'
import SlugGenerator from '@/components/SlugGenerator'
import SocialSharingMetaTag from '@/components/SocialSharingMetaTag'
import clone from 'lodash/clone'
import merge from 'lodash/merge'

const services = [
  {
    category: 'Sports',
    category_details: []
  },
  {
    category: 'Deposit',
    category_details: []
  },
  {
    category: 'Withdrawal Options',
    category_details: []
  }
]

export default {
  props: {
    bookmaker: {
      type: Object,
      default: function () {
        return null
      }
    },
    pageTitle: {
      type: String,
      default: 'Create Sportsbook'
    }
  },
  components: {
    PromoCardItem,
    PromoModalForm,
    AppBarNavIcon,
    ColorPicker,
    UsStatesSelector,
    UserAvatarUploader,
    ContentEditor,
    ImageUploader,
    SlugGenerator,
    SocialSharingMetaTag,
    FaqModalForm
  },
  watch: {
    bookmaker: {
      immediate: true,
      handler (val) {
        if (val) {
          this.form = new Form({
            _method: 'PUT',
            ...val,
            states: map(get(val, 'states', []), item => {
              return {
                us_states_id: item.id
              }
            }),
            review_author_name: get(val, 'review.author_name'),
            review_publish_status: get(val, 'review.publish_status'),
            review_rating: get(val, 'review.rating', 0),
            review_description: get(val, 'review.review_description'),
            review_pros: get(val, 'review.pros'),
            review_cons: get(val, 'review.cons'),
            review_avatar: get(val, 'review.review_avatar'),
            services: clone(merge(get(val, 'services'), services))
          })
        }
      }
    }
  },
  data () {
    return {
      tab: 0,
      showPromoModalForm: false,
      showFaqModalForm: false,
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      tabItems: [
        'Details',
        'Promos',
        'Review',
        'Services',
        'FAQ'
      ],
      tabKey: {
        promo: 1,
        faq: 4
      },
      publishStatusOptions: [
        'draft',
        'published'
      ],
      form: new Form({
        logo: null,
        banner_logo: null,
        welcome_logo: null,
        small_logo: null,
        name: null,
        website_url: null,
        bethub_code: null,
        state_ids: [],
        states: [],
        publish_status: 'draft',
        hex_color: '#FFFFFF',
        content_description: null,
        why_description: null,
        why_checklist: [],
        cta_title: null,
        cta_url: null,
        cta_btn_text: null,
        cta_bonuses: [],
        slug: null,
        image_meta: null,
        title_meta: null,
        description_meta: null,
        promos: [],
        review_author_name: null,
        review_description: null,
        review_rating: null,
        review_avatar: null,
        review_pros: [],
        review_cons: [],
        review_publish_status: 'draft',
        services: clone(services),
        faqs: []
      })
    }
  },
  computed: {
    states: {
      get () {
        return map(get(this.form, 'states', []), i => {
          return i.us_states_id
        })
      },
      set (val) {
        this.form.states = map(val, i => {
          return {
            us_states_id: i
          }
        })
      }
    },
    isModeUpdate () {
      return get(this.form, 'id', null) !== null
    },
    isPublished () {
      return get(this.form, 'publish_status') === 'published'
    }
  },
  methods: {
    get,

    showMessage (message, color = 'success') {
      this.snackbar.show = true
      this.snackbar.message = message
      this.snackbar.color = color
    },

    addReason () {
      if (this.form.why_checklist === null || this.form.why_checklist === undefined) {
        this.form.why_checklist = []
      }
      this.form.why_checklist.push('')
    },

    removeReason (i) {
      this.form.why_checklist.splice(i, 1)
    },

    addBonus () {
      if (this.form.cta_bonuses === null || this.form.cta_bonuses === undefined) {
        this.form.cta_bonuses = []
      }
      this.form.cta_bonuses.push('')
    },

    removeBonus (i) {
      this.form.cta_bonuses.splice(i, 1)
    },

    addPromo (val) {
      if (this.form.promos === null || this.form.promos === undefined) {
        this.form.promos = []
      }

      this.form.promos.push(val)
    },

    removePromo (i) {
      /**
       * @todo The errors are not properly deleted due to the index number changed
       */
      this.form.$clearError('promos.' + i + '.header')
      this.form.$clearError('promos.' + i + '.sub_header')
      this.form.$clearError('promos.' + i + '.affiliate_link')
      this.form.promos.splice(i, 1)
    },

    changePromo (i, $event) {
      this.form.promos.splice(i, i, $event)
    },

    addReviewPros () {
      if (this.form.review_pros === null || this.form.review_pros === undefined) {
        this.form.review_pros = []
      }
      this.form.review_pros.push('')
    },

    removeReviewPros (i) {
      this.form.review_pros.splice(i, 1)
    },

    addReviewCons () {
      if (this.form.review_cons === null || this.form.review_cons === undefined) {
        this.form.review_cons = []
      }
      this.form.review_cons.push('')
    },

    removeReviewCons (i) {
      this.form.review_cons.splice(i, 1)
    },

    addServiceCategoryDetails (i) {
      this.form.services[i].category_details.push('')
    },

    removeServiceCategoryDetails (i, k) {
      this.form.services[i].category_details.splice(k, 1)
    },

    addFAQ (value) {
      if (this.form.faqs === null || this.form.faqs === undefined) {
        this.form.faqs = []
      }

      this.form.faqs.push(value)
    },

    removeFAQ (i) {
      this.form.faqs.splice(i, 1)
    },

    async save () {
      try {
        this.form.$busy = true
        this.form.$clearErrors()
        const data = this.form.$data()

        // Clean up data
        data.why_checklist = filter(data.why_checklist, e => e !== null && e.trim() !== '')
        data.cta_bonuses = filter(data.cta_bonuses, e => e !== null && e.trim() !== '')
        data.review_pros = filter(data.review_pros, e => e !== null && e.trim() !== '')
        data.review_cons = filter(data.review_cons, e => e !== null && e.trim() !== '')

        const bookmaker = new Bookmaker(data)
        await bookmaker.save()

        if (this.isModeUpdate) {
          // @todo Thinks that are needed for updated only
          // e.g logo, images, avatar
        }

        this.$router.replace({ name: 'sportsbooks.list' })
      } catch (err) {
        if (err.response.status === 422) {
          this.form.$setErrors(err.response.data.errors)
          this.showMessage('Please review the following errors.', 'error')
        } else {
          this.showMessage(err, 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },

    publish () {
      this.form.publish_status = 'published'
      this.save()
    },

    unpublish () {
      this.form.publish_status = 'draft'
      this.save()
    },

    togglePublish () {
      if (this.isPublished) {
        this.unpublish()
      } else {
        this.publish()
      }
    }
  }
}
</script>
